<template>
  <vs-popup id="pdf-reader" :active.sync="popupActive">
      <iframe class="pdf-reader-iframe" :src="pdfReaderSrc">
          No document found.
      </iframe>
  </vs-popup>
</template>

<script>

export default {
  // This component is made to work in conjuntion with the FileDownloadMixin Mixin.
  // Both the mentioned Mixin and this component will have to be included in the parent view page.
  name: 'PDF-Reader',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    pdfReaderSrc: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
        popupActive: false,
    }
  },
  watch: {
    value: {
      handler(val) {
        this.popupActive = val;
      },
      immediate: true,
    },
    popupActive(val) {
      if (val === false) {
        this.$emit('input', val);
      }
    },
  },
}
</script>

<style lang="scss">
#pdf-reader {
  .vs-popup {
    height: 90vh;
    width: 90vw;

    .vs-popup--header {
      height: 0;

      h3 {
        display: none;
      }

      .vs-popup--close {
        -webkit-transform: translate(8px,10px);
        transform: translate(8px,10px);
      }
    }

    .vs-popup--content {
      height: 100%;
      width: 100%;
      max-height: none;
      margin: 0 !important;
      overflow: hidden;

      .pdf-reader-iframe {
        width: 100%;
        height: 100%;
        border: none;
      }
    }
  }
}
</style>